export default "__VITE_ASSET__Bk94FNtW__"